/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpagelivenote3Inputs */

const en_ticketpagelivenote3 = /** @type {(inputs: Ticketpagelivenote3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updates every 20 seconds`)
};

const de_ticketpagelivenote3 = /** @type {(inputs: Ticketpagelivenote3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktualisiert sich alle 20 Sekunden`)
};

/**
* | output |
* | --- |
* | "Updates every 20 seconds" |
*
* @param {Ticketpagelivenote3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpagelivenote3 = /** @type {((inputs?: Ticketpagelivenote3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpagelivenote3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpagelivenote3(inputs)
	return de_ticketpagelivenote3(inputs)
});
export { ticketpagelivenote3 as "ticketPageLiveNote" }